import axios from "axios";
//import { logout } from "../actions/login";

export default class HttpService {
  static setAxiosDefaults(token) {
    axios.defaults.baseURL = process.env.REACT_APP_BASE_URL + "/api";
    axios.defaults.headers.common["Authorization"] = token;
    /* axios.interceptors.response.use(
      (res) => res,
      (error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.code === 20
        ) {
          logout();
        }
        return error;
      }
    ); */
  }

  static clearToken() {
    delete axios.defaults.headers.common["Authorization"];
    axios.interceptors.response.use(
      (res) => res,
      (error) => error
    );
  }
}
